import { useTranslation } from 'react-i18next'

import { Gender } from '@/common/models/person'
import { UserType } from '@/common/models/user'
import { z } from '@/lib/zod'

export function FilterUserApplicationAccountUserSchema() {
  const { t } = useTranslation('sso')

  return z
    .object({
      freeSearch: z.string().nullable().optional(),
      userType: z.nativeEnum(UserType).nullable().optional(),
      gender: z.nativeEnum(Gender).nullable().optional(),
      birthMonth: z.string().nullable().optional(),
      birthYear: z.string().nullable().optional(),
      startCreated: z.date().nullable().optional(),
      endCreated: z.date().nullable().optional(),
    })
    .refine(
      (data) => {
        if (data.startCreated && data.endCreated) {
          return data.startCreated <= data.endCreated
        }
        return true
      },
      {
        message: t('access.drawer_filter.validations.start_end_date'),
        path: ['startCreated'],
      },
    )
    .refine((data) => (data.startCreated && !data.endCreated ? false : true), {
      message: t('access.drawer_filter.validations.end_date_required'),
      path: ['endCreated'],
    })
}

export type FilterUsersAccessForm = z.infer<
  ReturnType<typeof FilterUserApplicationAccountUserSchema>
>
